import cityData from '@/assets/data/cityData.json';
import routeData from '@/assets/data/routeData.json';
import pointData from '@/assets/data/pointData.json';
import gridData from '@/assets/data/gridData.json';
import chargerData from '@/assets/data/chargerData.json';
import exampleVehicles from '@/assets/data/exampleVehicles.json';
import ionityChargers from '@/assets/data/IONITYChargers.json';
import VehicleSidebar from '@/components/VehicleSidebar/VehicleSidebar.vue';
import CustomRoute from '@/components/CustomRoute/CustomRoute.vue';
import { coordinatesToCellCenter, coordinatesToCellPolygon } from '@/assets/helpers/grid-helper';
import { calculateEVRoutes, calculateCombustionRoute, calculateReachableRange, getOwnUrl } from '@/assets/helpers/TomTom';
import { toHHMMSS } from '@/assets/helpers/utility';
import $ from 'jquery';
const baseUrlCombustion = "https://api.tomtom.com/routing/1/calculateRoute";
const baseUrlEV =
    "https://api.tomtom.com/routing/1/calculateLongDistanceEVRoute";
const traffic = false;
const HeatmapOverlay = require('@/assets/helpers/leaflet-heatmap');

export default {
    components: { VehicleSidebar, CustomRoute },
    data () {
        return {
            map: null,
            routeLayer: null,
            vehicleLayers: {},
            vehicleControl: null,
            heatmapLayer: null,
            gridHeatmapLayer: null,
            gridVehiclesLayer: {},
            rangeLayer: null,
            chargerLayer: null,
            ionityLayer: null,
            cityLayer: null,
            gridLayer: null,
            navigationMarker: {start: null, dest: null},
            overlayMaps: {},
            popup: null,
            cityData: cityData,
            routeData: routeData,
            vehicleData: exampleVehicles,
            gasPrice: 2.0, // price per liter
            gasConsumption: 6.9, // liter per 100 km
            kWhPrice: 0.4, // price per kWh
            minRouteDistance: 100,
            chargerMinRatedKw: 50,
            chargerCount: 0,
            showChargers: false,
            attributeToCompare : "timeFactor",
            comparableAttributes: [
                { value: "timeFactor", text: "Time factor" },
                { value: "distanceFactor", text: "Distance factor" },
                { value: "costsFactor", text: "Costs factor" }
            ],
            mouseCoordinates: null,
            cellCenterMarker: null,
            cellPolygon: null,
            input: {
                vehicleData: JSON.stringify(exampleVehicles),
                apiKey: "",
            }
        };
    },
    computed: {
        navigationMarkersSet() {
            return (this.navigationMarker["start"] && this.navigationMarker["dest"])
        }
    },
    mounted() {
        this.loadLocalStorage();
        this.setupMap();
    },
    methods: {
        displayCustomRoute(response) {
            const vehicleInfo = {"name": "Test Vehicle", color: "#ff1234"};
            this.displayAPIResult(response, vehicleInfo);
        },
        showError(title, message) {
            this.$bvToast.toast(message, {
                title,
                autoHideDelay: 5000,
                variant: "danger"
            });
        },
        updateVehicleData(data) {
            this.vehicleData = data;
            localStorage.setItem("vehicleData", JSON.stringify(data));
            this.input.vehicleData = JSON.stringify(data);
        },
        setupRouteHeatmap() {         
            const cfg = {
                // radius should be small ONLY if scaleRadius is true (or small radius is intended)
                // if scaleRadius is false it will be the constant radius used in pixels
                "radius": 0.03,
                "maxOpacity": 0.65,
                // scales the radius based on map zoom
                "scaleRadius": true,
                "useLocalExtrema": false,
                latField: 'lat',
                lngField: 'long',
                // which field name in your data represents the data value - default "value"
                valueField: 'frequency'
            };
            let heatmapRouteLayer = new HeatmapOverlay(cfg);
            const heatmapData = {
                min: 0,
                max: 350,
                data: pointData
            };
            heatmapRouteLayer.setData(heatmapData);
            return heatmapRouteLayer;
        },
        setupGridHeatmap() {         
            const cfg = {
                // radius should be small ONLY if scaleRadius is true (or small radius is intended)
                // if scaleRadius is false it will be the constant radius used in pixels
                "radius": 0.1,
                "maxOpacity": 0.65,
                // scales the radius based on map zoom
                "scaleRadius": true,
                "useLocalExtrema": false,
                latField: 'lat',
                lngField: 'lng',
                // which field name in your data represents the data value - default "value"
                valueField: 'count'
            };
            var gridHeatmapLayer = new HeatmapOverlay(cfg);
            const _gridData = [];
            Object.keys(gridData).forEach((lat) => {
                const latEntry = gridData[lat];
                Object.keys(latEntry).forEach((lng) => {
                    const cellEntry = latEntry[lng];
                    _gridData.push({
                        lat,
                        lng,
                        "count": cellEntry.routes.length
                    })
                });
            });
            const heatmapData = {
                min: 0,
                max: 1000,
                data: _gridData
            };
            gridHeatmapLayer.setData(heatmapData);
            return gridHeatmapLayer;
        },
        setupGridVehicleLayers() {
            ["combustion", "audi", "peugeot", "fiat"].forEach((v) => {
                const cfg = {
                    // radius should be small ONLY if scaleRadius is true (or small radius is intended)
                    // if scaleRadius is false it will be the constant radius used in pixels
                    "radius": 0.1,
                    "maxOpacity": 0.65,
                    // scales the radius based on map zoom
                    "scaleRadius": true,
                    "useLocalExtrema": false,
                    latField: 'lat',
                    lngField: 'lng',
                    // which field name in your data represents the data value - default "value"
                    valueField: 'avg'
                };
                var gridHeatmapLayer = new HeatmapOverlay(cfg);
                const _gridData = [];
                var maxAvg = 0;
                var minAvg = 100;
                Object.keys(gridData).forEach((lat) => {
                    const latEntry = gridData[lat];
                    Object.keys(latEntry).forEach((lng) => {
                        const cellEntry = latEntry[lng];
                        const count = cellEntry[v].length;
                        if (count == 0)
                            return;
                        const sum = (cellEntry[v]).reduce((a, b) => a + b, 0);
                        const avg = (sum / cellEntry[v].length) || 0;
                        if (avg > maxAvg)
                            maxAvg = avg;
                        if (avg < minAvg)
                            minAvg = avg;
                        _gridData.push({
                            lat,
                            lng,
                            avg,
                            count
                        })
                    });
                });
                const heatmapData = {
                    min: minAvg,
                    max: maxAvg,
                    data: _gridData
                };
                gridHeatmapLayer.setData(heatmapData);
                this.gridVehiclesLayer[v] = gridHeatmapLayer;
            });
        },
        setupChargerHeatmap() {
            if (this.chargerLayer)
                this.chargerLayer.remove();
            const cfg = {
                // radius should be small ONLY if scaleRadius is true (or small radius is intended)
                // if scaleRadius is false it will be the constant radius used in pixels
                "radius": 0.02,
                "maxOpacity": 0.65,
                blur: 0.7,
                // scales the radius based on map zoom
                "scaleRadius": true,
                "useLocalExtrema": false,
                latField: 'lat',
                lngField: 'long',
                gradient: { "1": "#c7639f", "0": "#ffffff"},
                // which field name in your data represents the data value - default "value"
                valueField: 'count'
            };
            var heatmapLayer = new HeatmapOverlay(cfg);
            const chargers = chargerData.filter((c) => {
                if (!c.chargingPark)
                    return false;
                var powers = c.chargingPark.connectors;
                if (!powers)
                    return false;
                powers = powers.map((conn) => conn.ratedPowerKW);
                const max = Math.max(...powers);
                return max >= this.chargerMinRatedKw;
            })
            this.chargerCount = chargers.length;
            const improvedChargerData = chargers.map((c) => {
                return {
                    "lat": c.lat,
                    "long": c.lon,
                    "count": 1
                };
            });
            const heatmapData = {
                min: 0,
                max: 1,
                data: improvedChargerData
            };
            if (!this.showChargers)
                return;
            heatmapLayer.setData(heatmapData);
            this.chargerLayer = heatmapLayer;
            this.chargerLayer.addTo(this.map);
        },
        displayIonityChargers() {
            if (this.ionityLayer)
                this.ionityLayer.remove();
            const layer = this.ionityLayer = L.layerGroup();
            ionityChargers.locations.forEach((location) => {
                const myIcon = L.icon({
                    iconUrl: `https://ionity.eu/_Resources/Static/Packages/Ev.IonityPlace/Images/${location.status}.png`,
                    iconSize: [20, 32],
                });
                const marker = L.marker(location, {icon: myIcon}).addTo(layer);
                marker.bindTooltip(location.name);
                const content = document.createElement("div");
                content.innerHTML = `<h4> ${location.name} </h4> <p> ${location.description} </p>`;
                this.addNavigationButtons(content, marker.getLatLng());
                marker.bindPopup(content);
            });
        },
        loadLocalStorage() {
            try {
                this.input.apiKey = localStorage.getItem("API-Key");
                const rawVehicleData = localStorage.getItem("vehicleData");
                if (rawVehicleData) {
                    this.input.vehicleData = rawVehicleData;
                    this.vehicleData = JSON.parse(rawVehicleData);
                }
            }
            catch (e) {
                this.showError("Error while reading API-Key / Vehicle Data", e);
                console.warn("Error while reading API-Key / Vehicle Data");
                console.warn(e);
            }
            try {
                const urlSearchParams = new URLSearchParams(window.location.search);
                const params = Object.fromEntries(urlSearchParams.entries());
                if (params.apiKey) {
                    this.input.apiKey = params.apiKey
                    localStorage.setItem("API-Key", params.apiKey);
                }
                if(params.vehicleData) {
                    this.vehicleData = JSON.parse(params.vehicleData);
                    this.input.vehicleData = params.vehicleData;
                    localStorage.setItem("vehicleData", params.vehicleData);
                }
            } catch(e) {
                this.showError("Error while reading API-Key / Vehicle Data from Query", e);
                console.warn("Error while reading API-Key / Vehicle Data from Query");
                console.warn(e);
            }
            try {
                this.gasPrice = localStorage.getItem("gasPrice") ? localStorage.getItem("gasPrice") : this.gasPrice;
                this.gasConsumption = localStorage.getItem("gasConsumption") ? localStorage.getItem("gasConsumption") : this.gasConsumption;
                this.kWhPrice = localStorage.getItem("kWhPrice") ? localStorage.getItem("kWhPrice") : this.kWhPrice;
            }
            catch (e) {
                console.warn(e);
            }
            try {
                this.minRouteDistance = localStorage.getItem("minRouteDistance") ? localStorage.getItem("minRouteDistance") : this.minRouteDistance;
                this.attributeToCompare = localStorage.getItem("attributeToCompare") ? localStorage.getItem("attributeToCompare") : this.attributeToCompare;
            }
            catch (e) {
                console.warn(e);
            }
        },
        saveAPIKey(e) {
            if (e)
                e.preventDefault();
            localStorage.setItem("API-Key", this.input.apiKey);
            try {
                if(!this.input.vehicleData) {
                    return;
                }
                const rawVehicleData = this.input.vehicleData;
                const parsedData = JSON.parse(rawVehicleData);
                localStorage.setItem("vehicleData", JSON.stringify(parsedData));
                this.vehicleData = parsedData;
            }
            catch (err){
                window.alert(err);
                console.warn(err);
            }
        },
        applyCostData(e) {
            // e.preventDefault(); // This will prevent the page from reloading
            localStorage.setItem("gasPrice", this.gasPrice);
            localStorage.setItem("gasConsumption", this.gasConsumption);
            localStorage.setItem("kWhPrice", this.kWhPrice);
        },
        changeConstants(e) {
            // e.preventDefault(); // This will prevent the page from reloading
            localStorage.setItem("minRouteDistance", this.minRouteDistance);
            localStorage.setItem("attributeToCompare", this.attributeToCompare);
        },
        resetLocalStorage() {
            localStorage.clear();
            console.warn("You cleared the local storage. Reload page to get default values.");
            this.saveAPIKey(null); // we don't want to lose this!
        },
        setupMap() {
            this.map = L.map("map", { zoomControl: false }).setView([51.163361, 10.447683], 7);
            L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: `&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> <br />
                <a href="https://github.com/ElectricVehicleChargingCoverage/Visualizations"> GitHub-Code (private) </a><br />
                Cities: ${cityData.length}, Routes: ${routeData.length}`,
            }).addTo(this.map);
            this.addLayers();
            this.popup = L.popup();
            this.map.on("click", this.onMapClick);
            // GRID:
            this.cellCenterMarker = L.marker([0, 0]).addTo(this.gridLayer);
            this.cellPolygon = L.polygon([[0,0]]).addTo(this.gridLayer);
            this.map.on("mousemove", this.onMouseMove);
            // HELPER METHODS:
            this.calculateRouteScores();
            this.calculateCityScores();
            this.calculateGlobalScores();
            this.displayCities();
        },
        createVehicleLayer(name) {
            if (this.vehicleLayers[name])
                return;
            this.vehicleLayers[name] = L.layerGroup().addTo(this.map);
            this.vehicleLayers[name].on("add", (e) => {
                this.vehicleLayers[name].eachLayer((marker) => {
                    if (!marker._icon) return;
                    L.DomUtil.addClass(marker._icon, `${this.shortVehicleName(name)}-marker`)
                });
            });
            if (this.vehicleControl)
                this.map.removeControl(this.vehicleControl);
            this.vehicleControl = L.control.layers({}, this.vehicleLayers, { collapsed: false }).addTo(this.map);
        },
        addLayers() {
            const map = this.map;
            this.rangeLayer = L.layerGroup().addTo(map);
            this.cityLayer = L.layerGroup().addTo(map);
            this.routeLayer = L.layerGroup().addTo(this.cityLayer);
            this.heatmapLayer = this.setupRouteHeatmap();
            this.gridHeatmapLayer = this.setupGridHeatmap();
            this.displayIonityChargers();
            this.setupGridVehicleLayers();
            this.setupChargerHeatmap();
            this.gridLayer = L.layerGroup();
            this.overlayMaps = {
                "Scores": this.cityLayer,
                "Routepoints": this.heatmapLayer,
                "Grid points": this.gridHeatmapLayer,
                "Grid helper": this.gridLayer,
                "Reachable range": this.rangeLayer,
                "IONITY Chargers": this.ionityLayer
            };
            const vehicleHeatmaps = {
                "Audi E-Tron": this.gridVehiclesLayer.audi,
                "Peugeot e208": this.gridVehiclesLayer.peugeot,
                "Fiat 500e": this.gridVehiclesLayer.fiat,
                "Combustion": this.gridVehiclesLayer.combustion
            }
            L.control.layers({}, this.overlayMaps, { collapsed: false }).addTo(map);
            L.control.layers({}, vehicleHeatmaps, { collapsed: false, position: "bottomright" }).addTo(map);
        },
        onMouseMove(e) {
            this.mouseCoordinates = e.latlng;
            const cellCenter = coordinatesToCellCenter(e.latlng);
            const cellPolygon = coordinatesToCellPolygon(e.latlng);
            // this.cellCenterMarker.setLatLng([cellCenter.lat, cellCenter.lng]);
            this.cellPolygon.setLatLngs(cellPolygon);
            const entry = gridData[cellCenter.lat] ? gridData[cellCenter.lat][cellCenter.lng] : null;
            if (entry) {
                this.cellPolygon.setStyle({color: "blue"});
                ["audi", "peugeot", "fiat"].forEach((v) => {
                    const sum = (entry[v]).reduce((a, b) => a + b, 0);
                    const avg = (sum / entry[v].length) || 0;
                    entry[`${v}avg`] = avg;
                });
                this.cellPolygon.bindPopup(
                    `<h4> ${cellCenter.lat}, ${cellCenter.lng} </h4>
                    <p> Total Routes: ${entry.routes.length} </p>
                    <p> Combustion: ${entry.combustion.length} </p>
                    <p> Audi: ${entry.audi.length} (${entry.audiavg}) </p>
                    <p> Peugeot: ${entry.peugeot.length} (${entry.peugeotavg})</p>
                    <p> Fiat: ${entry.fiat.length} (${entry.fiatavg})</p>`,
                    { maxWidth: "600", className: "grid-popup" }
                );
            } else {
                this.cellPolygon.setStyle({color: "red"})
                this.cellPolygon.bindPopup(
                    `<h4> ${cellCenter.lat}, ${cellCenter.lng} </h4>
                    <h5> No routes </h5>`,
                    { maxWidth: "600", className: "grid-popup" }
                );
            }
        },
        addNavigationButtons(target, latlng) {
            const startButton = document.createElement("a");
            startButton.innerHTML = "Route from here";
            startButton.setAttribute("href", "#");
            startButton.onclick = () => {this.setNavigationMarker(latlng, true)};
            const destButton = document.createElement("a");
            destButton.innerHTML = "Route here";
            destButton.setAttribute("href", "#");
            destButton.style.right = "15px";
            destButton.style.position = "absolute";
            destButton.onclick = () => {this.setNavigationMarker(latlng, false)};
            target.appendChild(startButton);
            target.appendChild(destButton);
        },
        onMapClick(e) {
            // Create buttons to set navigation markers
            const content = document.createElement("div");
            content.innerHTML = `<h4> ${e.latlng.lat.toFixed(5).toString()}, ${e.latlng.lng
                        .toFixed(5)
                        .toString()} </h4>`
            this.addNavigationButtons(content, e.latlng);
            this.popup
                .setLatLng(e.latlng)
                .setContent(
                    content
                )
                .openOn(this.map);
            this.routeLayer.clearLayers();
        },
        setNavigationMarker(latlng, isStart) {
            this.popup.remove(); // close the popup
            const idx = isStart ? "start" : "dest";
            if (this.navigationMarker[idx])
                this.navigationMarker[idx].remove();
            const marker = L.marker(latlng, {draggable: true, autoPan: true}).addTo(this.map);
            L.DomUtil.addClass(
                marker._icon,
                `${idx}-marker`
            );
            marker.on("moveend", () => {this.calculateCustomRoute()});
            this.navigationMarker[idx] = marker;
            this.calculateCustomRoute();
        },
        copyNavigationRoute() {
            if (!(this.navigationMarker["start"] && this.navigationMarker["dest"]))
                return;
            const start = this.navigationMarker["start"].getLatLng();
            const dest = this.navigationMarker["dest"].getLatLng();
            const coordinates = `${start.lat},${start.lng}:${dest.lat},${dest.lng}`;
            const url = getOwnUrl(coordinates, this.vehicleData[0]);
            navigator.clipboard.writeText(url);
        },
        copyLinkWithKey() {
            // TODO: Copy link with API Key and vehicle data to clipboard
        },
        calculateCustomRoute() {
            if (!(this.navigationMarker["start"] && this.navigationMarker["dest"]))
                return;
            const start = this.navigationMarker["start"].getLatLng();
            const dest = this.navigationMarker["dest"].getLatLng();
            this.calculateRoutes([[start.lat, start.lng], [dest.lat, dest.lng]]);
        },
        displayCities() {
            const attributeToCompare = this.attributeToCompare
            const cityMinMax = this.analyzeAttribute(this.cityData, attributeToCompare);
            this.cityData.forEach((city) => {
                const score = city[attributeToCompare]["average"];
                if (!score) return;
                const radius = this.cityCircleSize(city);
                const color = this.getColor(cityMinMax, score);
                const circle = L.circle([city.lat, city.long], {
                    radius,
                    color,
                    fillOpacity: 0.4,
                    stroke: false,
                });
                circle.bindPopup(
                    `<h2>${city.name} (Score: ${score.toFixed(3)}) </h2>
                    ${this.createCityInfoTable(city)} `,
                    { maxWidth: "600", className: "city-popup" }
                );
                circle.bindTooltip(
                    `${city.name} (Score: ${score.toFixed(3)}) `,
                );
                circle.on("click", (e) => this.showRoutesFrom(city.name));
                circle.addTo(this.cityLayer);
            });
        },
        showRoutesFrom(startCity) {
            const routes = this.getRoutesOfCity(startCity);
            this.getOverheadScores(routes);
            this.routeLayer.clearLayers(); // Remove previously shown routes
            const minmax = this.analyzeAttribute(routes, this.attributeToCompare);
            routes.forEach((route) => {
                const score = route[this.attributeToCompare]["average"];
                const latlngs = [
                    [route["start_lat"], route["start_long"]],
                    [route["dest_lat"], route["dest_long"]],
                ];
                const color = this.getColor(minmax, score);
                var polyline = L.polyline(latlngs, { color, opacity: 0.7 });
                polyline.bindTooltip(
                    `${score.toFixed(3)}`
                );
                polyline.bindPopup(
                    `<h2> ${route.Start} -> ${route.Ziel} (Score: ${score.toFixed(3)})</h2> ${this.createRouteInfoTable(route)}`,
                    { maxWidth: "600", className: "route-popup" }
                );
                polyline.addTo(this.routeLayer);
                polyline.on("click", (e) => {
                    this.calculateRoutes(latlngs);
                });
            });
        },
        clearVehicleLayers() {
            Object.keys(this.vehicleLayers).forEach((layerName) => {
                if (this.vehicleLayers[layerName])
                    this.vehicleLayers[layerName].clearLayers();
            });
            this.rangeLayer.clearLayers();
        },
        displayChargingStop(stop, vehicle) {
            Object.assign(stop, stop.chargingInformationAtEndOfLeg);
            Object.assign(stop, stop.chargingConnectionInfo);
            const icon = L.icon({
                iconUrl: require("@/assets/images/ChargerIcon.png"),
                iconSize:     [40, 40],
                iconAnchor:   [20, 40],
                popupAnchor:  [0, 0]
            });
            var marker = L.marker(stop.location, {
                title: stop.chargingParkName,
                icon: icon,
                opacity: 1,
            }).addTo(this.vehicleLayers[vehicle.name]);
            if (marker._icon)
                L.DomUtil.addClass(
                    marker._icon,
                    `${this.shortVehicleName(vehicle.name)}-marker`
                );
            const infoTableObject = [ {name: vehicle.name, leg: stop}];
            marker.bindPopup(
                `<h2> ${stop.chargingParkName} (${
                    stop.chargingParkExternalId
                }) </h2> ${this.createChargerInfoTable(infoTableObject)}`,
                { maxWidth: "600", className: "charger-popup" }
            );
            marker.on("click", (e) => calculateReachableRange(stop.location, localStorage.getItem("API-Key"), vehicle, stop.chargingInformationAtEndOfLeg.targetChargeInkWh, this.displayRange));
        },
        displayRoute(latlngs, summary, chargingStops, vehicleInfo) {
            const polyline = L.polyline(latlngs);
            polyline.bindPopup(this.getPopupFromSummary(summary, vehicleInfo), {
                maxWidth: "600",
                className: "route-popup",
            });
            polyline.bindTooltip(vehicleInfo.name);
            this.createVehicleLayer(vehicleInfo.name);
            var options = { opacity: 0.75 };
            if (vehicleInfo.name == "Combustion") {
                options.color = "#000000";
                options.weight = 7;
                options.opacity = 0.3;
            } else {
                chargingStops.forEach((stop) => {this.displayChargingStop(stop, vehicleInfo);});
            }
            if (vehicleInfo.color)
                options.color = vehicleInfo.color;
            polyline.setStyle(options);
            polyline.addTo(this.vehicleLayers[vehicleInfo.name]);
        },
        // HELPER FILE HERE:
        analyzeAttribute(data, attribute) {
            const reducedData = data
                .map(function (item) {
                    return item[attribute]["average"];
                })
                .filter((value) => {
                    return !isNaN(value);
                });
            return {
                min: Math.min.apply(null, reducedData),
                max: Math.max.apply(null, reducedData),
            };
        },
        getOverheadScores(routes) {
            routes.forEach((route) => {
                const Fahrzeuge = route.Fahrzeuge;
                const timeoverhead =
                    (Fahrzeuge[1].dauer + Fahrzeuge[2].dauer + Fahrzeuge[3].dauer) /
                    (3 * Fahrzeuge[0].dauer);
                const umweg =
                    (Fahrzeuge[1].strecke +
                        Fahrzeuge[2].strecke +
                        Fahrzeuge[3].strecke) /
                    (3 * Fahrzeuge[0].strecke);
                route["timeoverhead"] = {};
                route["timeoverhead"]["average"] = timeoverhead;
                route["umweg"] = {};
                route["umweg"]["average"] = umweg;
            });
        },
        getColor(minmax, value) {
            const min = minmax.min;
            const max = minmax.max;
            if (value <= min) {
                return "rgb(0, 255, 0)";
            } else if (value >= max) {
                return "rgb(255, 0, 0)";
            } else {
                const v = (value - min) / (max - min);
                const red = Math.round(v * 255);
                const green = 255 - red;
                return `rgb(${red}, ${green}, 0)`;
            }
        },
        createRouteInfoTable(route) {
            const attributes = [
                {
                    display: "Distance",
                    method: (vehicle) => {
                        return vehicle["strecke"]
                            ? `${(vehicle["strecke"] / 1000).toFixed(0)} km`
                            : "-";
                    },
                },
                {
                    display: "Distancefactor",
                    method: (vehicle, route) => {
                        return route["distanceFactor"][vehicle.name]
                            ? `${parseFloat(
                                route["distanceFactor"][vehicle.name].toFixed(3)
                            )}`
                            : "-";
                    },
                },
                {
                    display: "Distancedifference",
                    method: (vehicle, route) => {
                        return route["distanceDifference"][vehicle.name]
                            ? `${parseFloat(
                                (
                                    route["distanceDifference"][vehicle.name] / 1000
                                ).toFixed(3)
                            )} km`
                            : "-";
                    },
                },
                {
                    display: "Duration",
                    method: (vehicle) => {
                        return vehicle["dauer"] ? toHHMMSS(vehicle["dauer"]) : "-";
                    },
                },
                {
                    display: "Timefactor",
                    method: (vehicle, route) => {
                        return route["timeFactor"][vehicle.name]
                            ? `${parseFloat(
                                route["timeFactor"][vehicle.name].toFixed(3)
                            )}`
                            : "-";
                    },
                },
                {
                    display: "Timedifference",
                    method: (vehicle, route) => {
                        return route["timeDifference"][vehicle.name]
                            ? `${toHHMMSS(route["timeDifference"][vehicle.name])}`
                            : "-";
                    },
                },
                {
                    display: "Consumption",
                    method: (vehicle) => {
                        return vehicle["verbrauch"]
                            ? `${vehicle["verbrauch"].toFixed(2)} ${
                                vehicle.name == "Verbrenner" ? "l" : "kWh"
                            }`
                            : "-";
                    },
                },
                {
                    display: "Remaining charge",
                    method: (vehicle) => {
                        return vehicle["restreichweite"]
                            ? `${vehicle["restreichweite"].toFixed(1)} kWh`
                            : "-";
                    },
                },
                {
                    display: "Charging time",
                    method: (vehicle) => {
                        return vehicle["ladezeit"]
                            ? toHHMMSS(vehicle["ladezeit"])
                            : "-";
                    },
                },
                {
                    display: "Charging stops",
                    method: (vehicle) => {
                        return vehicle["legs"]
                            ? vehicle["legs"].length > 0
                                ? vehicle["legs"].length - 1
                                : "-"
                            : "-";
                    },
                },
                {
                    display: "Costs",
                    method: (vehicle) => {
                        return vehicle["costs"]
                            ? `${vehicle["costs"].toFixed(2)} &euro;`
                            : "-";
                    },
                },
                {
                    display: "Costs factor",
                    method: (vehicle, route) => {
                        return route["costsFactor"][vehicle.name]
                            ? `${parseFloat(
                                route["costsFactor"][vehicle.name].toFixed(2)
                            )}`
                            : "-";
                    },
                },
            ];
            var table = `<table> <tr>
                    <th> </th>
                    <th>Combustion</th>
                    <th>Audi E-Tron</th>
                    <th>Peugeot e208</th>
                    <th>Fiat 500e</th>
                </tr>`;
            attributes.forEach((attribute) => {
                table += `<tr> <td> ${attribute.display} </td>`;
                route.Fahrzeuge.forEach((fahrzeug) => {
                    table += `<td> ${
                        fahrzeug.strecke ? attribute.method(fahrzeug, route) : "-"
                    } </td>`;
                });
                table += "</tr> ";
            });
            table += "</table> ";
            return table;
        },

        createChargerInfoTable(chargerInfo) {
            const attributes = [
                {
                    name: "lengthInMeters",
                    display: "Distance",
                    method: (e) => {
                        return `${(e / 1000).toFixed(0)} km`;
                    },
                },
                {
                    name: "travelTimeInSeconds",
                    display: "Duration",
                    method: (e) => {
                        return toHHMMSS(e);
                    },
                },
                {
                    name: "batteryConsumptionInkWh",
                    display: "Consumption",
                    method: (e) => {
                        return e ? `${e.toFixed(2)} kWh` : "-";
                    },
                },
                {
                    name: "remainingChargeAtArrivalInkWh",
                    display: "Remaining Charge",
                    method: (e) => {
                        return e ? `${e.toFixed(1)} kWh` : "-";
                    },
                },
                {
                    name: "chargingTimeInSeconds",
                    display: "Charging time",
                    method: (e) => {
                        return e ? toHHMMSS(e) : "-";
                    },
                },
                {
                    name: "targetChargeInkWh",
                    display: "Target charge",
                    method: (e) => {
                        return e ? `${e.toFixed(1)} kWh` : "-";
                    },
                },
                {
                    name: "chargingPowerInkW",
                    display: "Chargingpower",
                    method: (e) => {
                        return e ? `${e} kW` : "-";
                    },
                },
            ];
            var table = `<table> <tr>
                    <th>Since last stop</th>`;
            chargerInfo.forEach((fahrzeug) => {
                table += `<th> ${fahrzeug.name} </th>`;
            });
            table += `</tr>`;
            attributes.forEach((attribute) => {
                table += `<tr> <td> ${attribute.display} </td>`;
                chargerInfo.forEach((fahrzeug) => {
                    table += `<td> ${
                        attribute.method
                            ? attribute.method(fahrzeug.leg[attribute.name])
                            : fahrzeug.leg[attribute.name]
                    } </td>`;
                });
                table += "</tr> ";
            });
            table += "</table> ";
            return table;
        },

        createCityInfoTable(city) {
            const Vehicles = ["Verbrenner", "Audi E-Tron", "Peugeot e208", "Fiat 500e"];
            const attributes = [
                {
                    display: "Timefactor",
                    method: (city, vehicle) => {
                        return parseFloat(city["timeFactor"][vehicle].toFixed(3));
                    },
                },
                {
                    display: "Timedifference",
                    method: (city, vehicle) => {
                        return toHHMMSS(city["timeDifference"][vehicle]);
                    },
                },
                {
                    display: "Distance-factor",
                    method: (city, vehicle) => {
                        return parseFloat(city["distanceFactor"][vehicle].toFixed(3));
                    },
                },
                {
                    display: "Detour",
                    method: (city, vehicle) => {
                        return `${
                            city["distanceDifference"][vehicle].toFixed(0) / 1000
                        } km`;
                    },
                },
                {
                    display: "Costs",
                    method: (city, vehicle) => {
                        return `${city["costs"][vehicle].toFixed(2)} &euro;`;
                    },
                },
                {
                    display: "Cost factor",
                    method: (city, vehicle) => {
                        return `${parseFloat(city["costsFactor"][vehicle].toFixed(2))}`;
                    },
                },
                {
                    display: "Number of routes",
                    method: (city, vehicle) => {
                        const routes = this.getRoutesOfCity(city.name).filter((r) => {
                            return r.distanceFactor[vehicle] != null;
                        });
                        return `${routes.length}`;
                    },
                },
            ];
            var table = `<table> <tr>
                    <th>Averages</th>
                    <th>Combustion</th>
                    <th>Audi E-Tron</th>
                    <th>Peugeot e208</th>
                    <th>Fiat 500e</th>
                </tr>`;
            attributes.forEach((attribute) => {
                table += `<tr> <td> ${attribute.display} </td>`;
                Vehicles.forEach((vehicle) => {
                    table += `<td> ${attribute.method(city, vehicle)} </td>`;
                });
                table += "</tr> ";
            });
            table += "</table> ";
            return table;
        },

        compareVehicleScoresForCity(
            city,
            vehicle,
            attribute,
            get_difference = true
        ) {
            const routes = this.getRoutesOfCity(city.name);
            const mapped = routes
                .map((route) => {
                    return route[
                        `${attribute}${get_difference ? "Difference" : "Factor"}`
                    ][vehicle];
                })
                .filter((value) => value != undefined);
            const sum = mapped.reduce((a, b) => a + b, 0);
            const avg = sum / mapped.length || 0;
            return avg;
        },

        getCostsForRoutes() {
            const gasConsumption = this.gasConsumption;
            this.routeData.forEach((route) => {
                route.Fahrzeuge.forEach((fahrzeug) => {
                    if (fahrzeug.name == "Verbrenner") {
                        const distance = fahrzeug["strecke"];
                        fahrzeug["verbrauch"] = (distance * gasConsumption) / 100000;
                        fahrzeug["costs"] =
                            ((distance * gasConsumption) / 100000) * this.gasPrice;
                    } else {
                        const consumption = fahrzeug["verbrauch"];
                        fahrzeug["costs"] = consumption * this.kWhPrice;
                    }
                });
            });
        },

        getCostsForCity(city, vehicle) {
            const routes = this.getRoutesOfCity(city.name);
            if (vehicle == "Verbrenner") {
                const mapped = routes.map((route) => route.Fahrzeuge[0]["strecke"]);
                const sum = mapped.reduce((a, b) => a + b, 0);
                const avg = sum / mapped.length || 0;
                return ((avg * this.gasConsumption) / 100000) * this.gasPrice;
            } else {
                const mapped = routes.map((route) => {
                    return route.Fahrzeuge.filter((fahrzeug) => {
                        return fahrzeug.name == vehicle;
                    })[0]["verbrauch"];
                });
                const sum = mapped.reduce((a, b) => a + b, 0);
                const avg = sum / mapped.length || 0;
                return avg * this.kWhPrice;
            }
        },
        getRoutesOfCity(cityname) {
            return this.routeData.filter(
                (route) =>
                    route.Start == cityname &&
                    this.getDistance(
                        [route["start_lat"], route["start_long"]],
                        [route["dest_lat"], route["dest_long"]]
                    ) >= this.minRouteDistance
            );
        },
        getDistance(latlng1, latlng2) {
            const dy = 111.3 * (latlng1[0] - latlng2[0]);
            const dx = 71.5 * (latlng1[1] - latlng2[1]);
            return Math.sqrt(dx * dx + dy * dy); // in km
        },
        shortVehicleName(name) {
            return name.split(" ")[0];
        },

        httpGetAsync(theUrl, callback, callbackInfo = null) {
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
                    if (callbackInfo) callback(xmlHttp.responseText, callbackInfo);
                    else callback(xmlHttp.responseText);
            };
            xmlHttp.open("GET", theUrl, true); // true for asynchronous
            xmlHttp.send(null);
        },

        httpPostAsync(theUrl, body, callback, callbackInfo = null) {
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                    if (callbackInfo) callback(xmlHttp.responseText, callbackInfo);
                    else callback(xmlHttp.responseText);
                } else if (xmlHttp.readyState == 4) {
                    console.warn(xmlHttp.status, xmlHttp.responseText);
                }
            };
            xmlHttp.open("POST", theUrl, true); // true for asynchronous
            xmlHttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xmlHttp.send(body);
        },

        getPopupFromSummary(summary, vehicleInfo) {
            if (!summary)
                return "<h2> No summary provided </h2>";
            var result = `<h2> ${
                vehicleInfo.name == "Verbrenner" ? "Combustion (as infinite EV)" : vehicleInfo.name
            } </h2>
            <table> <tr> <th> Attribute </th> <th> Value </th> </tr>`;
            const attributes = [
                {
                    name: "Distance",
                    method: (s) => {
                        return `${(s.lengthInMeters / 1000).toFixed(1)} km`;
                    },
                },
                {
                    name: "Traveltime",
                    method: (s) => {
                        return toHHMMSS(s.travelTimeInSeconds);
                    },
                },
                {
                    name: "Charging time",
                    method: (s) => {
                        return s.totalChargingTimeInSeconds ? toHHMMSS(s.totalChargingTimeInSeconds) : "-";
                    },
                },
                {
                    name: "Battery consumption",
                    method: (s) => {
                        if (!s.batteryConsumptionInkWh)
                            return "-";
                        return `${Math.floor(s.batteryConsumptionInkWh * 100) / 100} kWh`;
                    },
                },
                {
                    name: "Remaining charge",
                    method: (s) => {
                        if (!s.remainingChargeAtArrivalInkWh)
                            return "-";
                        return `${Math.floor(s.remainingChargeAtArrivalInkWh * 100) / 100} kWh`;
                    },
                },
                {
                    name: "Gasoline Costs",
                    method: (s) => {
                        return `${(((s.lengthInMeters * this.gasConsumption) / 100000) * this.gasPrice).toFixed(2)} &euro;`;
                    },
                },
                {
                    name: "EV Costs",
                    method: (s) => {
                        if (!s.batteryConsumptionInkWh)
                            return "-";
                        return `${(s.batteryConsumptionInkWh * this.kWhPrice).toFixed(2)} &euro;`;
                    },
                },
            ];
            attributes.forEach((attribute) => {
                const data = attribute.method(summary);
                result += `<tr> <td> ${attribute.name} </td> <td> ${data} </td></tr>`;
            });
            result += "</table>";
            return result;
        },
        calculateCityScores() {
            const Vehicles = ["Verbrenner", "Audi E-Tron", "Peugeot e208", "Fiat 500e"];
            const attributes = [
                {
                    name: "timeFactor",
                    method: (a, b) => {
                        return this.compareVehicleScoresForCity(a, b, "time", false);
                    },
                },
                {
                    name: "timeDifference",
                    method: (a, b) => {
                        return this.compareVehicleScoresForCity(a, b, "time", true);
                    },
                },
                {
                    name: "distanceFactor",
                    method: (a, b) => {
                        return this.compareVehicleScoresForCity(a, b, "distance", false);
                    },
                },
                {
                    name: "distanceDifference",
                    method: (a, b) => {
                        return this.compareVehicleScoresForCity(a, b, "distance", true);
                    },
                },
                {
                    name: "costs",
                    method: (a, b) => {
                        return this.getCostsForCity(a, b);
                    },
                },
                {
                    name: "costsFactor",
                    method: (city, vehicle) => {
                        return city["costs"][vehicle] / city["costs"]["Verbrenner"];
                    },
                },
            ];
            cityData.forEach((city) => {
                attributes.forEach((attribute) => {
                    city[attribute.name] = {};
                    var sum = 0;
                    var count = 0;
                    Vehicles.forEach((vehicle) => {
                        city[attribute.name][vehicle] = attribute.method(city, vehicle);
                        if (
                            vehicle == "Verbrenner" ||
                            city[attribute.name][vehicle] == 0
                        )
                            return;
                        sum += city[attribute.name][vehicle];
                        count += 1;
                    });
                    city[attribute.name]["average"] = sum / count;
                });
            });
        },
        calculateRouteScores() {
            const attributes = [
                { name: "strecke", new: "distance" },
                { name: "dauer", new: "time" },
                { name: "costs", new: "costs" },
            ];
            this.getCostsForRoutes();
            this.routeData.forEach((route) => {
                attributes.forEach((attribute) => {
                    route[`${attribute.new}Factor`] = {};
                    route[`${attribute.new}Difference`] = {};
                    var sumFactor = 0;
                    var sumDifference = 0;
                    var count = 0;
                    route.Fahrzeuge.forEach((fahrzeug) => {
                        if (fahrzeug.strecke == null) return;
                        const combustionAttribute = route.Fahrzeuge[0][attribute.name];
                        const vehicleAttribute = fahrzeug[attribute.name];
                        route[`${attribute.new}Factor`][fahrzeug.name] =
                            vehicleAttribute / combustionAttribute;
                        route[`${attribute.new}Difference`][fahrzeug.name] =
                            vehicleAttribute - combustionAttribute;
                        if (fahrzeug.name == "Verbrenner") return;
                        sumFactor += route[`${attribute.new}Factor`][fahrzeug.name];
                        sumDifference +=
                            route[`${attribute.new}Difference`][fahrzeug.name];
                        count += 1;
                    });
                    route[`${attribute.new}Factor`]["average"] = sumFactor / count;
                    route[`${attribute.new}Difference`]["average"] =
                        sumDifference / count;
                });
            });
        },
        calculateGlobalScores() {
            const attributes = ["distance", "time", "costs"];
            var result = "";
            attributes.forEach((attribute) => {
                const mapped = cityData
                    .map((city) => city[`${attribute}Factor`]["average"])
                    .filter((value) => !isNaN(value));
                const value = mapped.reduce((a, b) => a + b, 0) / mapped.length;
                result += `${attribute} factor: ${parseFloat(value.toFixed(3))} <br />`;
            });
            $("#global-scores").html(result);
        },
        cityCircleSize(city) {
            const score = city[this.attributeToCompare]["average"];
            switch (this.attributeToCompare) {
                case "timeFactor":
                    return 3000 * Math.pow(score, 5);
                case "distanceFactor":
                    return 12000 * Math.pow((score - 1) * 5 + 1, 9);
                case "costsFactor":
                    return 100 * Math.pow(score * 5, 5);
            }
            return 10000;
        },
        /**
         * Calculates routes for all vehicles: combustion vehicle and all vehicles spedified in this.vehicleData.
         * Requires a valid API-Key in localStorage "API-Key".
         * @param {[[startLat, startLong], [destLat, destLong]]} coords Coordinates of the start and destination point.
         */
        calculateRoutes(coords) {
            this.clearVehicleLayers(); // Clear previous routes
            const coordinates = `${coords[0][0]},${coords[0][1]}:${coords[1][0]},${coords[1][1]}`;
            const key = localStorage.getItem("API-Key");
            if (key && key.match("[a-zA-Z0-9]{30,35}")) {
                calculateCombustionRoute(coordinates, key, this.displayAPIResult);
                if (!this.vehicleData || this.vehicleData.length == 0) {
                    console.warn("Please enter vehicleData suitable for routing to use this feature.");
                    return;
                }
                calculateEVRoutes(coordinates, key, this.vehicleData, this.displayAPIResult, this);
            } else if (!key || key == ""){
                console.warn("Enter an API Key to show the actual routes");
            } else {
                window.alert(
                    `Invalid API-Key: "${key}". If you are sure, that your key is correct, notify us to adapt the regex for evaluating.`
                );
            }
        },

        displayAPIResult(response, vehicleInfo) {
            const json = JSON.parse(response);
            const route = json.routes[0];
            const legs = route.legs;
            const summary = route.summary;
            const latlngs = [];
            const chargingStops = [];
            legs.forEach((leg) => {
                const points = leg.points;
                points.forEach((point) => {
                    latlngs.push([point.latitude, point.longitude]);
                });
                if (!leg.summary)
                    return;
                if (leg.summary.chargingInformationAtEndOfLeg == null) return;
                leg.summary["location"] = latlngs[latlngs.length - 1]; // set last point of leg as charger location
                chargingStops.push(leg.summary);
            });
            this.displayRoute(latlngs, summary, chargingStops, vehicleInfo);
        },

        displayRange(response, vehicleInfo) {
            const json = JSON.parse(response);
            this.rangeLayer.clearLayers();
            const boundary = json.reachableRange.boundary;
            const latlngs = boundary.map(coords => [coords.latitude, coords.longitude]);
            const options = {
                opacity: 0.3,
            };
            const polygon = L.polygon(latlngs, options).addTo(this.rangeLayer);
            polygon.bringToBack();
        }
    }
}